import { PAGES, DICTIONARIES, DICTIONARY_KEYNAME } from "@/common/consts";
import { readLocalStorage, writeLocalStorage } from "./localStorageUtils";

export const getDefaultDictionariesByPage = (routeName = "") => {
	if (typeof routeName !== "string") routeName = "";

	switch (routeName) {
		case PAGES.HOME:
		case PAGES.WWF:
		case PAGES.WORDS_CONSONANTS:
		case PAGES.WORDS_VOWELS:
		case PAGES.WORDS_ENDING_ING:
		case PAGES.WORDS_WITH_Q_NO_U:
		case PAGES.WORDS_BY_LENGTH_RESULTS:
		case PAGES.WORDS_ENDING_RESULTS:
		case PAGES.WORDS_HAVING_RESULTS:
		case PAGES.WORDS_STARTING_RESULTS:
			return DICTIONARIES[1];
		case PAGES.UNSCRAMBLE:
		case PAGES.WORD_DESCRAMBLER:
		case PAGES.SCRABBLE_DICT:
		case PAGES.SCRABBLE_DICT_RESULTS:
		case PAGES.SCRABBLE_EXACTMATCH_RESULTS:
			return DICTIONARIES[2];
		case PAGES.WORDFEUD:
			return DICTIONARIES[12];
		case PAGES.WORD_CONNECT:
			return DICTIONARIES[7];
		case PAGES.WORDBRAIN_ANSWERS:
			return DICTIONARIES[13];
		case PAGES.WORD_STORY:
			return DICTIONARIES[14];
		case PAGES.WORD_CHUMS_CHEAT:
			return DICTIONARIES[9];
		case PAGES.UNSCRAMBLER_RESULTS:
			return DICTIONARIES[1];
		case PAGES.ANAGRAM:
			return DICTIONARIES[4];
		case PAGES.FOURPICS:
			return DICTIONARIES[5];
		case PAGES.JUMBLE_SOLVER:
			return DICTIONARIES[5];
		case PAGES.WORDCOOKIES:
			return DICTIONARIES[8];
		case PAGES.TEXT_TWIST:
			return DICTIONARIES[10];
		case PAGES.CODY_CROSS:
			return DICTIONARIES[11];
		case PAGES.WORD_SWIPE_CHEATS:
			return DICTIONARIES[15];
		default:
			return DICTIONARIES[16];
	}
};

export const getDictionaries = () => {
	let dictionaryList = [];
	Object.entries(DICTIONARIES).forEach(([key]) =>
		dictionaryList.push({
			id: key,
			text: `DictionaryMenuSection${key}Text`,
			value: DICTIONARIES[key],
			titleAttribute: `DictionaryMenuSection${key}TitleAttribute`,
			ariaLabel: `DictionaryMenuSection${key}AriaLabel`,
		})
	);
	return dictionaryList;
};

export const getDictionaryByValue = (val) => {
	return getDictionaries().find((dict) => dict.value === val);
};

/**
 * Return true if the given route is or is under Scrabble Dictionary section
 * @param {String} routeName - A $route.name string
 * @return {Boolean} true if route is a results page; false otherwise.
 */
export const isScrabbleDictionaryPage = (routeName) => {
	return (
		routeName === PAGES.SCRABBLE_DICT ||
		routeName === PAGES.SCRABBLE_DICT_RESULTS ||
		routeName === PAGES.SCRABBLE_EXACTMATCH_RESULTS
	);
};

export const writeDictionary = (dictionary) => {
	writeLocalStorage(DICTIONARY_KEYNAME, dictionary);
};

export const readDictionary = (defaultValue = null) => {
	if (!navigator.cookieEnabled) return defaultValue;
	let dict = readLocalStorage(DICTIONARY_KEYNAME);

	// If the dictionary stored in Local Storage is no longer available, return the default value.
	if (
		!dict.length ||
		!Object.entries(DICTIONARIES).some((e) => e[1] === dict[0].dict)
	) {
		return defaultValue;
	}

	return dict[0].dict;
};

export const isScrabbleDictionary = (dictionary) => {
	return (
		dictionary.value === DICTIONARIES[2] ||
		dictionary.value === DICTIONARIES[3]
	);
};

export const isScrabbleDictResultsPage = (route) => {
	return route.name === PAGES.SCRABBLE_DICT_RESULTS;
};

export const isUnscrambleResultsPage = (route) => {
	return route.name === PAGES.UNSCRAMBLER_RESULTS;
};

export const isLandingPage = (routeName) => {
	return [
		PAGES.HOME,
		PAGES.WWF,
		PAGES.WORDS_CONSONANTS,
		PAGES.WORDS_VOWELS,
		PAGES.WORDS_ENDING_ING,
		PAGES.WORDS_WITH_Q_NO_U,
		PAGES.UNSCRAMBLE,
		PAGES.WORD_DESCRAMBLER,
		PAGES.WORD_UNSCRAMBLER,
		PAGES.SCRABBLE_DICT,
		PAGES.WORDFEUD,
		PAGES.WORD_CONNECT,
		PAGES.WORDBRAIN_ANSWERS,
		PAGES.WORD_STORY,
		PAGES.WORD_CHUMS_CHEAT,
		PAGES.ANAGRAM,
		PAGES.FOURPICS,
		PAGES.JUMBLE_SOLVER,
		PAGES.WORDCOOKIES,
		PAGES.TEXT_TWIST,
		PAGES.CODY_CROSS,
		PAGES.WORD_SWIPE_CHEATS,
	].includes(routeName);
};
